import { navigate } from '~/helpers/consts';
import { t } from '~/helpers/localization';
import { CREWS_CATEGORY, DOLLS_CATEGORY, ENSIGNS_CATEGORY, PERMOFLAGES_CATEGORY, PROFILE_PAGE, SHIPDESTRUCTION_CATEGORY, VEHICLE_CATEGORY } from '~/interfaces';

export type NavItemType = {
    link: string;
    name: string;
    title: string;
};

export default [
    {
        link: navigate[PROFILE_PAGE],
        name: PROFILE_PAGE,
        title: t('Главная'),
    },
    {
        link: navigate[VEHICLE_CATEGORY],
        name: VEHICLE_CATEGORY,
        title: t('Корабли'),
    },
    {
        link: navigate[CREWS_CATEGORY],
        name: CREWS_CATEGORY,
        title: t('Командиры'),
    },
    {
        link: navigate[PERMOFLAGES_CATEGORY],
        name: PERMOFLAGES_CATEGORY,
        title: t('Камуфляжи'),
    },
    {
        link: navigate[ENSIGNS_CATEGORY],
        name: ENSIGNS_CATEGORY,
        title: t('Флаги'),
    },
    {
        link: navigate[DOLLS_CATEGORY],
        name: DOLLS_CATEGORY,
        title: t('Знаки различия'),
    },
    {
        link: navigate[SHIPDESTRUCTION_CATEGORY],
        name: SHIPDESTRUCTION_CATEGORY,
        title: t('Эффекты уничтожения'),
    },
] as NavItemType[];
